import { Core, Decorative } from "@faire/design-tokens";
import { FlashSaleImageGridV2 } from "@faire/retailer-visitor-shared/components/FlashSaleBundleTile/FlashSaleImageGridV2";
import { NoTranslate } from "@faire/retailer-visitor-shared/components/NoTranslate";
import { useSettingDealsHub } from "@faire/retailer-visitor-shared/settings/useSettingDealsHub";
import { formatMoney, moneyOrZero } from "@faire/web/common/money";
import { Avatar } from "@faire/web/slate/deprecated/Avatar";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Link } from "@faire/web/ui/LinkAnchor";
import { IFlashSaleTile } from "@faire/web-api--source/indigofair/data/IFlashSaleTile";
import flashSaleflashSaleToken from "@faire/web-api--source/routes/www/flash-sale/flashSaleToken";
import React from "react";
import styled from "styled-components";

interface IProps {
  item: IFlashSaleTile;
  onClick?: (token: string) => void;
}

export const FlashSaleBundleTile: React.FC<IProps> = (props) => {
  const {
    token,
    image,
    product_images,
    discount_percentage,
    price,
    original_price,
    brand_name,
  } = props.item;
  const isFlashDealsRevamp = useSettingDealsHub();

  return (
    <Wrapper
      onClick={() => {
        props.onClick?.(token ?? "");
      }}
      data-test-id="flash-sale-bundle-tile"
      to={flashSaleflashSaleToken(token ?? "")}
      style={{
        border: isFlashDealsRevamp ? `none` : `1px solid ${Core.border.muted}`,
      }}
    >
      <FlashSaleImageGridV2 images={product_images} />
      <Content>
        <Avatar size="small" image={image} />
        <Spacer width="2x" />
        <Column>
          <Row>
            <Typography variant="paragraphSansMedium" maxLines={1}>
              <NoTranslate>{brand_name}</NoTranslate>
            </Typography>
          </Row>
          <PriceInfoContainer>
            <Typography color={Decorative.shade.orange}>
              {formatMoney({
                money: moneyOrZero(price),
              })}
            </Typography>
            <Spacer width={4} />
            <Typography color={Core.text.subdued} strikethrough>
              {formatMoney({
                money: moneyOrZero(original_price),
              })}
            </Typography>
            <Spacer width={4} />
            {discount_percentage ? (
              <Typography>
                <StrictLocalMsg
                  defaultMessage="({discountPercentageNumber}% off)"
                  values={{
                    discountPercentageNumber: discount_percentage,
                  }}
                />
              </Typography>
            ) : null}
          </PriceInfoContainer>
        </Column>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  background-color: ${Core.surface.inverse};
`;

const Content = styled(Row).attrs({ align: "center" })`
  padding: ${getSpacing("2x")};
`;

const PriceInfoContainer = styled(Row)`
  flex-wrap: wrap;
`;
